export default __webpack_public_path__ + "static/media/arrow-down.48a1dc3a.svg";